import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';

import { Lang } from '../../../i18n/messages';
import { LocaleService } from '../../../services/locale.service';

/**
 * Bascule de langue segmentée **EN | FR** (look inspiré du switch Termii).
 * Segment actif = pastille verte marque Nawam. Piloté par `LocaleService`
 * (signal `lang`, persisté). Deux emplacements dans le shell : coin haut-droit
 * des pages auth + bas du sidebar (avec label « Langue »).
 */
@Component({
  selector: 'app-language-switch',
  standalone: true,
  template: `
    <div
      class="inline-flex items-center gap-0.5 rounded-lg bg-gray-100 p-0.5 dark:bg-white/[0.06]"
      role="group"
      aria-label="Langue / Language"
    >
      @for (opt of options; track opt.value) {
        <button
          type="button"
          (click)="locale.set(opt.value)"
          [attr.aria-pressed]="locale.lang() === opt.value"
          [ngClass]="
            locale.lang() === opt.value
              ? 'bg-brand-500 text-white shadow-theme-xs'
              : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-white/90'
          "
          class="rounded-md px-2.5 py-1 text-xs font-semibold uppercase transition"
        >
          {{ opt.label }}
        </button>
      }
    </div>
  `,
  imports: [NgClass],
})
export class LanguageSwitchComponent {
  readonly locale = inject(LocaleService);

  readonly options: { value: Lang; label: string }[] = [
    { value: 'en', label: 'EN' },
    { value: 'fr', label: 'FR' },
  ];
}
